<template>
<div v-if="ready" style="padding:20px 20px 20px 20px;">
  <schedaHeader scheda="5" titolo="DIMISSIONE" :item="item"></schedaHeader>

  <el-form ref="formBasic" :model="item.row" @submit.native.prevent="onSubmit" :rules="rulesForm" label-width="360px" class="label-50">



   <div class="formRow row">

      <div class="col s12">       
         <formLabel variabile="dataesito"></formLabel>       
         <el-form-item prop="dataesito">       
         <el-date-picker v-model="item.row.dataesito" type="date" placeholder="Indica la data" style="width:100%;" format="dd-MM-yyyy" value-format="yyyy-MM-dd" ></el-date-picker>       
         </el-form-item>       
      </div>

      <div class="col s12" v-if="this.$moment(item.row.dataesito)>=this.$moment(item.row.dataricovero) ">
         <formLabel variabile="los1"></formLabel>
         <el-form-item prop="los1">
         <div class="yo-align-left" style="padding-left:12px;">{{this.$moment(item.row.dataesito).diff( this.$moment(item.row.dataricovero) ,'days')+1}}</div>
         </el-form-item>
      </div>

<!--
  <div class="col s12">       <formLabel variabile="los1"></formLabel>       <el-form-item prop="los1">       <formRangeV3 v-model="item.row.los1" variabile="los1"></formRangeV3>       </el-form-item>       </div>
-->

<div class="col s12" v-if="isAlivePlus">       <formLabel variabile="fdisp"></formLabel>       <el-form-item prop="fdisp">       <formSelectV3 v-model="item.row.fdisp" variabile="fdisp"></formSelectV3>       </el-form-item>       </div>

<div class="col s12" v-if="isAliveLocate">       <formLabel variabile="entfeed"></formLabel>       <el-form-item prop="entfeed">       <formSelectV3 v-model="item.row.entfeed" variabile="entfeed"></formSelectV3>       </el-form-item>       </div>




<div class="col s12" v-if="isAlive">       <formLabel variabile="supportodim"></formLabel>       <el-form-item prop="supportodim">       <formSelectV3 v-on:change="changeSupportodim()" v-model="item.row.supportodim" variabile="supportodim"></formSelectV3>       </el-form-item>       </div>


<div class="col s12" v-if="isAlive && item.row.gruppo==1 && item.row.supportodim==1">       <formLabel variabile="oxfinal"></formLabel>       <el-form-item prop="oxfinal">       <formSelectV3 v-model="item.row.oxfinal" variabile="oxfinal"></formSelectV3>       </el-form-item>       </div>


<div class="col s12" v-if="isAlive && item.row.gruppo==1 && item.row.supportodim==1">       <formLabel variabile="ventfinal"></formLabel>       <el-form-item prop="ventfinal">       <formSelectV3 v-model="item.row.ventfinal" variabile="ventfinal"></formSelectV3>       </el-form-item>       </div>
<div class="col s12" v-if="isAlive && item.row.gruppo==1 && item.row.supportodim==1">       <formLabel variabile="hfvfinal"></formLabel>       <el-form-item prop="hfvfinal">       <formSelectV3 v-model="item.row.hfvfinal" variabile="hfvfinal"></formSelectV3>       </el-form-item>       </div>

<div class="col s12" v-if="isAlive && item.row.gruppo==1 && item.row.supportodim==1">       <formLabel variabile="hfncfinal"></formLabel>       <el-form-item prop="hfncfinal">       <formSelectV3 v-model="item.row.hfncfinal" variabile="hfncfinal"></formSelectV3>       </el-form-item>       </div>
<div class="col s12" v-if="isAlive && item.row.gruppo==1 && item.row.supportodim==1 && item.row.hfncfinal==1">       <formLabel variabile="ncffinal_gt_2l"></formLabel>       <el-form-item prop="ncffinal_gt_2l">       <formSelectV3 v-model="item.row.ncffinal_gt_2l" variabile="ncffinal_gt_2l"></formSelectV3>       </el-form-item>       </div>

<div class="col s12" v-if="isAlive && item.row.gruppo==1 && item.row.supportodim==1">       <formLabel variabile="nimvfinal"></formLabel>       <el-form-item prop="nimvfinal">       <formSelectV3 v-model="item.row.nimvfinal" variabile="nimvfinal"></formSelectV3>       </el-form-item>       </div>
<div class="col s12" v-if="isAlive && item.row.gruppo==1 && item.row.supportodim==1">       <formLabel variabile="cpapfinal"></formLabel>       <el-form-item prop="cpapfinal">       <formSelectV3 v-model="item.row.cpapfinal" variabile="cpapfinal"></formSelectV3>       </el-form-item>       </div>
<div class="col s12" v-if="isAlive && item.row.gruppo==1 && item.row.supportodim==1">       <formLabel variabile="acfinal"></formLabel>       <el-form-item prop="acfinal">       <formSelectV3 v-model="item.row.acfinal" variabile="acfinal"></formSelectV3>       </el-form-item>       </div>



<div class="col s12" v-if="isAliveLocate">       <formLabel variabile="dwgt"></formLabel>       <el-form-item prop="dwgt">       <formRangeV3 v-model="item.row.dwgt" variabile="dwgt"></formRangeV3>       </el-form-item>       </div>
<div class="col s12" v-if="isAliveLocate">       <formLabel variabile="dheadcir"></formLabel>       <el-form-item prop="dheadcir">       <formRangeV3 v-model="item.row.dheadcir" variabile="dheadcir"></formRangeV3>       </el-form-item>       </div>
<div class="col s12" v-if="isAliveLocate">       <formLabel variabile="ldimissione"></formLabel>       <el-form-item prop="ldimissione">       <formRangeV3 v-model="item.row.ldimissione" variabile="ldimissione"></formRangeV3>       </el-form-item>       </div>


   </div>

    <div v-if="item.row.chiusoil=='0000-00-00 00:00:00'" class="row" style="margin-top:20px;border-top:1px solid #379EC2;padding-top:20px;">           
      <div class="col s12 m3">
        <el-button style="width:100%;"  @click="onCancel">Indietro</el-button>
        </div> 
      <div class="col s12 m4 offset-m5">
        <el-button type="primary" @click="onSubmit" class="yo-bg-color-secondary" style="width:100%;border:none;">Salva e procedi</el-button>
      </div>
    </div>

    <div v-else class="row" style="margin-top:20px;border-top:1px solid #379EC2;padding-top:20px;">           
      <div class="col s12 m4 offset-m8" >
        <el-button style="width:100%;"  @click="$router.push('/home')">Annulla</el-button>
      </div>
    </div>


  



  </el-form>



</div>
</template>

<script>
/*
QUERY
SELECT id,LOWER(nome),posizione,tipo,risposte,answer,nc,na,domanda,help FROM `variabile` WHERE scheda=5 ORDER BY posizione
*/
import schedaHeader from './Scheda-header.vue'
import formLabel from './Form-label.vue'
import formSelectV3 from './Form-select-v3.vue'
import formRangeV3 from './Form-range-v3.vue'

import dbItem from '../teras/dbItem'

export default {
  name: 'scheda-datigenerali',
  components: {
     schedaHeader
     ,formLabel
     ,formSelectV3
     ,formRangeV3
  },
  data() {
    return {
      loading:{}
      ,ready: false
      ,item:{}
      ,inDate: (rule, value, callback) => {
        let message = (typeof rule.message == 'string') ? rule.message : 'La data non è valida'
        if (this.$moment(value).isBetween(rule.mindate, rule.maxdate) || this.$moment(value).isSame(rule.mindate) || this.$moment(value).isSame(rule.maxdate)) {
          callback();
        } else {
          callback(new Error(message));
        }
      }
    }
  },
  created: async function () {
    console.log("Arrivo  scheda-datigenerali.vue con id "+this.$route.params.id)
    this.loading = this.$loading({lock: true, text: 'Caricamente in corso, non ricaricare la pagina.....', spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.7)' })

    this.item = new dbItem({table:'paziente'})
    await this.item.load(this.$route.params.id)
    if(this.item.row.centro==0)
      this.item.row.centro = this.$centro.referente.row.centro

    if(this.item.rowIsNew){
      this.item.row.creatoil=this.$moment().format('YYYY-MM-DD H:mm:ss')
      this.item.row.creatoda=this.$teras.utente.id//this.$centro.referente.row.id

      this.item.row.byear = this.$moment().format('YYYY')
    }else{
      //mettere il nome della pagina cme modifica
    }

    for (let property in this.item.row){
      if(this.item.row[property]==-7)
        this.item.row[property]=-127
    }
      
      
    setTimeout(() =>{ 
      this.loading.close()
      this.ready = true 
    }, 1000)


  },
  methods: {
    changeSupportodim: function (){
      if(this.item.row.supportodim==1){
          if(this.item.row.oxfinal<0) this.item.row.oxfinal = -127;
          if(this.item.row.ventfinal<0) this.item.row.ventfinal = -127;
          if(this.item.row.hfvfinal<0) this.item.row.hfvfinal = -127;
          if(this.item.row.hfncfinal<0) this.item.row.hfncfinal = -127;
          if(this.item.row.nimvfinal<0) this.item.row.nimvfinal = -127;
          if(this.item.row.cpapfinal<0) this.item.row.cpapfinal = -127;
          if(this.item.row.acfinal<0) this.item.row.acfinal = -127;
      }

    },
    onSubmit: async function() {
      this.$refs.formBasic.validate(async (valid) => {
        if (valid) {      
          
          this.item.row.modificatoil=this.$moment().format('YYYY-MM-DD H:mm:ss')
          this.item.row.modificatoda=this.$teras.utente.id//this.$centro.referente.row.id

          let error = -1

          if(this.$moment(this.item.row.dataricovero) > this.$moment(this.item.row.dataesito).add(0,'days'))
            error = 103

          if(this.$moment(this.item.row.dataesito) > this.$moment(this.item.row.datanascita).add(364,'days'))
            error = 104

          if(this.item.row.dheadcir>this.item.row.ldimissione && this.item.row.dheadcir>0 && this.item.row.ldimissione>0)
            error = 108


          switch (error){
            case -1:
            this.loading = this.$loading({lock: true, text: 'Caricamente in corso, non ricaricare la pagina.....', spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.7)' })
            if(this.item.row.chiusoil=='0000-00-00 00:00:00'){
              await this.item.save()
              await this.$axios.query('doQuery',`CALL paziente_check_risposte(←id,@nome, @numero);`,{id: this.item.row.id})
              await this.$centro.getPaziente()
            }
            this.loading.close()
            if(this.item.row.fdisp==2){
              this.$router.push('/scheda-trasferimento/'+this.item.row.id)
            }else{
              this.$router.push('/home/')
            }
            break;

            case 103:
            this.$notify.error({title: 'Errore '+error,message: 'Il giorno di esito deve essere maggiore della data di ricovero e data di nasciata!'})
            break;

            case 104:
            this.$notify.error({title: 'Errore '+error,message: 'Il giorno di esito deve essere minore o uguale al primo anno di età del bambino!'})
            break;

            case 108:
            this.$notify.error({title: 'Errore '+error,message: 'La circonferenza cranica non può essere maggiore della lunghezza!'})
            break;

            default:
            this.$notify.error({title: 'Errore non specificato',message: 'Siamo spiacenti si è verificato un errore, la preghiamo di verificare i dati inseriti!'})
          }


          

        } else {
          this.$notify.error({title: 'Errore',message: "Non tutti i campi sono stati compilati correttamente!"})
          return false
        }
      })
    }
    ,onCancel() {
        //this.$router.go(-1)
        this.$router.push('/scheda-decorso/'+this.item.row.id)
    }

  },
  computed: {
    isAlive: function(){
      return (this.item.row.deldie!=1) ? true : false;
    },
    isAlivePlus: function(){
      return (this.item.row.deldie!=1 && this.item.row.die12!=1) ? true : false;
    },
    isAliveLocate: function(){
      return (this.item.row.locate==0 && this.item.row.deldie!=1 && this.item.row.die12!=1) || (this.item.row.locate==1) ? true : false;
    },
    rulesForm:function() {
      //.add(120, 'd') tolto perchè adele ha chiesto precedente alla data di modifica
      var rulesNow = {
        dataesito:[
          { required: true, message: 'Il campo è obbligatorio'},
          { validator: this.inDate, mindate:this.$moment(this.item.row.datanascita), maxdate:this.$moment(), message: 'La data di esito deve essere successiva alla data di nascita e precedente a quella attuale'  }
        ]

      }
      return rulesNow
    }
  }
}
</script>
<style >
.formRow{

}.formRow > .col {
    background-color: #F9F9FA;
}.formRow > .col:nth-child(odd) {
    background-color: #EFF0F2;
}.formRow > .col .el-form-item{
  margin-top:10px;
  margin-bottom:18px;
}.formRow > .col .el-form-item__content{
  margin-right:12px;

  
}
</style>